<template>
  <div id="instrument-equipment">

    <common-search :searchList="searchList" @onSearch="onSearch" type="products"></common-search>

    <common-table
      :product_list="product_list"
      :loading="loading"
      @sort-change="sortChange"
      @data-change="getMessageByPage"
      storageName="checkedHeaders"
      title="商品列表"
      type="products"
      height="650"
      :tableHandler="tableHandler"
      ></common-table>

    <div style="text-align: right;margin-top:10px">
       <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'instrument-equipment',
  data() {
    return {
      userType: 4,
      product_list: null,
      searchList: {
        name: '',category: '',status: '',price: '',stock: '' ,createdAt: '',updatedAt: '',
      },
      tableHandler: [
        'show','edit','del'
      ],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 10,
      loading: false,
      newSearchList: null,
    }
  },
  mounted(){
    this.userType = localStorage.getItem('userType');
    this.getMessageByPage();
  },

  methods: {
    async getMessageByPage(cb){
      this.loading = true;
      let _searchList = this.newSearchList ? this.newSearchList : this.searchList
      let options = this.$util.formatOptions(_searchList);
      if(this.$util.isEmpty(this.order))
        this.order = "default";
      const product_list = await this.$request.get_message('products',{page: this.currentPage,limit: this.pageSize,query: options});
      //console.log(product_list);
      if(product_list.code === 0){
        product_list.data.forEach(product => {
          if(product.tags) product.tags = product.tags.split(',')
          else product.tags = [];
        })
        this.product_list = product_list.data;
        this.total = product_list.total;
      }else{
        this.$message(product_list.errMsg)
      }

      cb && cb(product_list.total);

      this.loading = false;
    },

    handleSizeChange(val) { //更改显示数据行数
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },

    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },

    onSearch(val){
      this.$commondata.searchObj = this.searchList;
      this.newSearchList = Object.assign({}, this.searchList);
      if(val.price !== ''){
        this.newSearchList.price = val.price;
      }
      if(val.stock !== ''){
        this.newSearchList.stock = val.stock;
      }
      this.getMessageByPage();
    }
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-equipment{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Equipment.vue